import { render, staticRenderFns } from "./ArchivoImagen.vue?vue&type=template&id=63d1cc79&scoped=true"
import script from "./ArchivoImagen.vue?vue&type=script&lang=js"
export * from "./ArchivoImagen.vue?vue&type=script&lang=js"
import style0 from "./ArchivoImagen.vue?vue&type=style&index=0&id=63d1cc79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d1cc79",
  null
  
)

export default component.exports